/* pantalla principal donde se enlistan los catalogos */
import { useState, useEffect } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Grid,
    Tab,
    Tabs,
    Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import React from "react";
import BreadcrumbBar from "../../../layout/BreadcrumbBar";

// definicio de como se comporta al pasar y seleccionar un boton de la pantalla
const MenuSX = {
    // cuando seleccionas una opcion
    "&& .Mui-selected, && .Mui-selected:hover": {
        bgcolor: "#bda889",
        "&, & .MuiButton-root": { color: "#212121" },
    },
    // cuando pasas el mouse sobre
    "& .MuiButton-root:hover": {
        bgcolor: "#bda889",
        "&, & .MuiButton-root": { color: "#ffffff" },
    },
};
// definicio del color del texto de los botones de catalogos
const ButtonSX = { color: "black" };

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

//funcion principal

//hola
const Catalogos = () => {
    const [panelValue, setPanelValue] = useState(0);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setPanelValue(newValue);
    };

    useEffect(() => {
        if (localStorage.getItem("panelvalue")) {
            setPanelValue(parseInt(localStorage.getItem("panelvalue")!));
        } else {
            setPanelValue(0);
        }
    }, []);
    const navigate = useNavigate();

    return (
        <Grid container>
            <BreadcrumbBar
                links={[
                    { texto: "Inicio", link: "/admin" },
                    // { texto: "Configuración", link: "#" },
                ]}
                Titulo="Catálogos"
            />
            <Grid container xs={12} justifyContent={"center"}>
                <Grid item xs={12} md={12} mt={2}>
                    <Card sx={{ p: 1, boxShadow: 8 }}>
                        <CardHeader
                            title="Catálogos de Plataforma Portal de Participaciones y Aportaciones Federales y Estatales"
                        // subheader="Catálogos de Plataforma de Parque Vehicular"
                        />
                        <CardContent>
                            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                                <Tabs
                                    value={panelValue}
                                    onChange={handleChange}
                                    textColor="inherit"
                                    variant="fullWidth"
                                    // este SX es de la barra donde se muestran los tabs
                                    sx={{
                                        "& .MuiTabs-indicator": {
                                            backgroundColor: "#bda889",
                                            heigth: 4,
                                        },
                                        "& .Mui-selected": {
                                            backgroundColor: "#bda889",
                                            color: "#ffffff",
                                        },
                                        "& button": { borderRadius: 5 },
                                        // pasa el mouse
                                        "& button:hover": {

                                        },
                                    }}
                                >
                                    <Tab label="Generales" {...a11yProps(0)} />


                                </Tabs>
                            </Box>
                            {/* panel de generales */}
                            <TabPanel value={panelValue} index={0}>
                                <Grid sx={MenuSX} container spacing={2}>

                                    <Grid item xs={12} md={6} lg={4}>
                                        <Button
                                            sx={ButtonSX}
                                            variant="text"
                                            fullWidth
                                            onClick={() =>
                                                navigate(
                                                    "/admin/catalogos/fondos"
                                                )
                                            }
                                        >
                                            CATALOGO FONDOS
                                        </Button>
                                    </Grid>
                                    {/* <Grid item xs={12} md={6} lg={4}>
                                        <Button
                                            sx={ButtonSX}
                                            variant="text"
                                            fullWidth
                                            onClick={() =>
                                                navigate(
                                                    "/admin/catalogos/proceso"
                                                )
                                            }
                                        >
                                            CATALOGO TIPO DE PROCESOS
                                        </Button>
                                    </Grid> */}
                                    <Grid item xs={12} md={6} lg={4}>
                                        <Button
                                            sx={ButtonSX}
                                            variant="text"
                                            fullWidth
                                            onClick={() =>
                                                navigate(
                                                    "/admin/catalogos/enlaces"
                                                )
                                            }
                                        >
                                            CATALOGO DE ENLACES
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <Button
                                            sx={ButtonSX}
                                            variant="text"
                                            fullWidth
                                            onClick={() =>
                                                navigate(
                                                    "/admin/catalogos/municipios"
                                                )
                                            }
                                        >
                                            CATALOGO DE	MUNICIPIOS
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <Button
                                            sx={ButtonSX}
                                            variant="text"
                                            fullWidth
                                            onClick={() =>
                                                navigate(
                                                    "/admin/catalogos/tipopublicacion"
                                                )
                                            }
                                        >
                                           CATALOGO DE TIPO DE PUBLICACIÓN
                                        </Button>
                                    </Grid>

                                </Grid>
                            </TabPanel>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Catalogos;